import { FC } from 'react';
import { RectSkeleton } from 'shared/ui/Skeleton/RectSkeleton';

export const EditBuildingSkeleton: FC = () => {
  return <RectSkeleton width={606} height={400} />;
};
